import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-block.svg'


const _withScopeId = n => (_pushScopeId("data-v-3571f018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "section border-b"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información del accionista", -1))
const _hoisted_5 = { class: "flex lg:flex-row flex-col gap-4" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_9 = { class: "col-span-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "10px",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normal-case h-full" }, "Cambiar contraseña", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "section border-t border-b" }
const _hoisted_14 = { class: "section-title" }
const _hoisted_15 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_16 = { class: "m-2" }
const _hoisted_17 = { class: "h-2/6 ml-auto" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_change_password_form = _resolveComponent("change-password-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.shareholder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (
          _ctx.shareholder.isBusiness &&
          _ctx.shareholder.businessName &&
          _ctx.shareholder.businessAddress &&
          _ctx.shareholder.businessRut
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_TextField, {
                    class: "flex-1",
                    model: _ctx.shareholder.businessName,
                    "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shareholder.businessName) = $event)),
                    type: "text",
                    name: "company",
                    label: "Razón social",
                    "has-error": false,
                    "error-message": "'Error'",
                    "hide-details": "",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changed = true))
                  }, null, 8, ["model"]),
                  _createVNode(_component_TextField, {
                    class: "flex-1",
                    model: _ctx.shareholder.businessAddress,
                    "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shareholder.businessAddress) = $event)),
                    type: "text",
                    name: "address",
                    label: "Dirección",
                    "has-error": false,
                    "error-message": "'Error'",
                    "hide-details": "",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changed = true))
                  }, null, 8, ["model"]),
                  _createVNode(_component_TextField, {
                    model: _ctx.shareholder.businessRut,
                    "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shareholder.businessRut) = $event)),
                    type: "text",
                    name: "",
                    label: "Rut",
                    "has-error": _ctx.rutFieldHasError,
                    "error-message": "El rut no es válido o no se encuentra en el formato indicado (Ej: 12345678-9)",
                    "hide-details": "",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changed = true))
                  }, null, 8, ["model", "has-error"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.shareholder.isBusiness
              ? "Información representante"
              : "Información del accionista"), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_TextField, {
                class: "lg:col-span-1 col-span-4",
                model: _ctx.shareholder.firstName,
                "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shareholder.firstName) = $event)),
                type: "text",
                name: "firstName",
                label: "Nombre",
                "has-error": false,
                "error-message": "Nombre no valido",
                "hide-details": "",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.lastName,
                "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.shareholder.lastName) = $event)),
                type: "text",
                name: "lastName",
                label: "Apellido",
                "has-error": false,
                "error-message": "Apellido indicado no es valido",
                "hide-details": "",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.rut,
                "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shareholder.rut) = $event)),
                type: "text",
                name: "userRut",
                label: "Rut",
                "has-error": _ctx.rutFieldHasError,
                "error-message": "El rut ingresado no es valido o no tiene un formato correcto (Ej: 12345678-9)",
                "hide-details": "",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model", "has-error"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.address,
                "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.shareholder.address) = $event)),
                type: "text",
                name: "address",
                label: "Dirección particular",
                "has-error": false,
                "error-message": "La dirección ingresada no es valida",
                "hide-details": "",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.county,
                "onUpdate:model": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.shareholder.county) = $event)),
                type: "text",
                name: "contry",
                label: "Comuna",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.region,
                "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.shareholder.region) = $event)),
                type: "text",
                name: "region",
                label: "Región",
                "has-error": false,
                "error-message": "'Error'",
                "hide-details": "",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.openChangePasswordModal && _ctx.openChangePasswordModal(...args))),
                  class: "flex items-center justify-center h-full gap-2"
                }, _hoisted_12)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.shareholder.isBusiness
              ? "Información representante"
              : "Datos de contacto"), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.email,
                "onUpdate:model": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.shareholder.email) = $event)),
                type: "text",
                name: "",
                label: "Email",
                "has-error": false,
                "error-message": "El email no es correcto",
                "hide-details": "",
                onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                class: "col-span-4 lg:col-span-1",
                model: _ctx.shareholder.phone,
                "onUpdate:model": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.shareholder.phone) = $event)),
                type: "text",
                name: "phone",
                label: "Celular",
                "has-error": false,
                "error-message": "El número de telefono ingresado no es valido",
                "hide-details": "",
                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.changed = true))
              }, null, 8, ["model"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          class: "success w-36 btn ml-auto my-auto",
          disabled: !_ctx.changed,
          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.submitUser && _ctx.submitUser(...args)))
        }, " Guardar ", 8, _hoisted_18)
      ])
    ]),
    (_ctx.showChangePasswordModal)
      ? (_openBlock(), _createBlock(_component_change_password_form, {
          key: 1,
          visible: _ctx.showChangePasswordModal,
          "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showChangePasswordModal) = $event))
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}